import { SECONDS_IN_MINUTE } from '../constants';

function timeUntilFullMinute(dateObject) {
    if (dateObject instanceof Date) {
        return SECONDS_IN_MINUTE - dateObject.getSeconds();
    }
    return '';
}

export default timeUntilFullMinute;
